<template>
    <div class="current-plan" @click="showPlans(type)" :class="{ trialPlan: trialPlan }">
        <div class="trial-plan" v-if="trialPlan">{{ $t("billing.free") }}</div>
        <div class="current-plan-head">
            <div class="current-plan-title">
                {{ $t(`message.plans.types.${type.replace("-", "_")}`) }}

            </div>
            <div style="display: grid; grid-template-columns: auto auto; column-gap: 4px">
                <div class="current-plan-status" v-if="planAction">{{ $t("billing.packageManagement") }}</div>
                <div class="current-plan-status" v-else>{{ $t("billing.buyIt") }}</div>
            </div>
        </div>
        <div class="current-plan-body">
            <div class="current-plan-details">
                <div class="plan-detail">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.packageType')"
                    >
                        {{ $t("billing.packageType") }}
                    </div>
                    <div>
                        {{ (planAction && plan && plan.altTitle) || "N/A" }}
                    </div>
                </div>
                <div class="plan-detail">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.packagePeriod')"
                    >
                        {{ $t("billing.packagePeriod") }}
                    </div>
                    <div>
                        {{ (planAction && formatPeriod(planAction.period)) || "N/A" }}
                    </div>
                </div>
                <div
                    class="plan-detail"
                    v-if="type === 'chatbot'"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                    }"
                    :content="$t('billing.maxChatbotSession')"
                >
                    <div>{{ $t("billing.chatbotLimit") }}</div>
                    <div>{{ features.totalSessionCount }}</div>
                </div>
                <div
                    class="plan-detail"
                    v-if="type == 'supsis'"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                    }"
                    :content="$t('message.agentCount')"
                >
                    <div>{{ $t("message.agentCount") }}</div>
                    <div>
                        {{ features.maxAgentCount || 1 }}
                        <div v-if="features.freeAgentCount > 0">
                            ({{ features.freeAgentCount }} {{ $t("billing.free") }})
                        </div>
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'whatsapp' || type === 'whatsapp-business'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{
                            type === "whatsapp"
                                ? features.maxWhatsappChannel
                                : features.maxBusinessWhatsappChannel || "N/A"
                        }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'instagram'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{ features.maxInstagramChannel || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'messenger'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{ features.maxMessengerChannel || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'meta-lead'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{ features.maxMetaLeadChannel || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'automation'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('message.automationTasks')"
                    >
                        {{ $t("message.automationTasks") }}
                    </div>
                    <div>
                        {{ features.maxAutomationTask || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'trendyol'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{ features.maxTrendyolChannel || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="type === 'webphone'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.channelCount')"
                    >
                        {{ $t("billing.channelCount") }}
                    </div>
                    <div>
                        {{ features.maxWebphoneChannel || 0 }}
                    </div>
                </div>
                <div class="plan-detail" v-if="planAction && planAction.period === 'forever'">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.remainingTime')"
                    >
                        {{ $t("billing.remainingTime") }}
                    </div>
                    <div>∞</div>
                </div>
                <div class="plan-detail" v-else-if="!detailPackage().enabled">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.remainingTime')"
                    >
                        {{ $t("billing.remainingTime") }}
                    </div>
                    <div>{{ $t("auto.notAvailable") }}</div>
                </div>
                <div class="plan-detail" v-else-if="!detailPackage().renewed">
                    <div
                        v-tippy="{
                            followCursor: true,
                            placement: 'bottom-end',
                        }"
                        :content="$t('billing.remainingTime')"
                    >
                        {{ $t("billing.remainingTime") }}
                    </div>
                    <div>{{ $t("message.daysRemaining", { count: detailPackage().leftTime }) }}</div>
                </div>
                <div
                    class="plan-detail"
                    v-else-if="detailPackage().renewed"
                    v-tippy="{
                        followCursor: true,
                        placement: 'bottom-end',
                    }"
                    :content="$t('billing.renewalDate')"
                >
                    <div>{{ $t("billing.renewalDate") }}</div>
                    <div>{{ detailPackage().endDate }}</div>
                </div>
            </div>
            <div class="image">
                <DynamicSvg :name="getIcon(type)" />
            </div>
        </div>
    </div>
</template>
<script>
import DynamicSvg from "../DynamicSvg.vue";
import moment from "moment";

export default {
    name: "CurrentPlanCard",
    components: {
        DynamicSvg,
    },
    props: {
        type: {
            type: String,
            default: null,
        },
        planAction: {
            default: null,
        },
        plan: {
            default: null,
        },
        features: {
            type: Object,
            default: () => ({}),
        },
        trialPlan: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({
        icons: {
            whatsapp: "CWhatsapp",
            "whatsapp-business": "WhatsappBusinessNew",
            supsis: "CSupsis",
            chatbot: "ChatbotNew",
            instagram: "CInstagram",
            telegram: "TelegramEntegration",
            custom: "CSupsis",
            appsumo: "AppSumo",
            messenger: "Messenger",
            trendyol: "trendyol",
            "meta-lead": "MetaIcon",
            "customer-tables": "CustomerTables",
            form: "Form",
            automation: "Automation",
            mail: "Mail",
            tasks: "Tasks",
            "webhook": "WebhookIntegration",
            "webphone": "Webphone",
        },
    }),
    methods: {
        showPlans(planType) {
            this.$emit("show-plans", planType);
        },
        getIcon(type) {
            return this.icons[type] || "CSupsis";
        },
        detailPackage() {
            let detail = {
                enabled: false,
                renewed: false,
                leftTime: 0,
                endDate: null,
            };
            if (this.planAction) {
                const isYearly = this.planAction.period === "annual";
                const startDate = moment();
                detail.leftTime = moment(this.planAction.endDate).diff(startDate, "days");
                if (this.planAction.enabled && !this.planAction.endDate) {
                    detail.renewed = true;
                    detail.endDate = moment()
                        .add(1, isYearly ? "year" : "month")
                        .startOf(isYearly ? "year" : "month")
                        .format("YYYY/MM/DD");
                }
                detail.enabled = true;
            }
            return detail;
        },
        formatPeriod(period) {
            const periods = {
                monthly: "Aylık",
                "monthly-3": "3 Aylık",
                "monthly-6": "6 Aylık",
                annual: "Yıllık",
                "annual-2": "2 Yıllık",
                forever: "Ömür Boyu",
            };
            return periods[period];
        },
    },
};
</script>
<style lang="scss">
.current-plan {
    padding: 20px;
    border-radius: 8px;
    cursor: pointer;
    white-space: nowrap;
    border: 1px solid var(--color-border-default);
    padding-top: 20px !important;
    position: relative;
    overflow: hidden;

    &.trialPlan {
        border: 1px solid var(--color-text-primary-strong-active);

        .trial-plan {
            background: var(--color-text-primary-strong-active);
            color: white;
            position: absolute;
            top: 0;
            left: 0;
            padding: 2px 10px;
            font-size: 10px;
            line-height: 18px;
            font-weight: bold;
        }
    }
    &:hover {
        box-shadow: rgba(0, 0, 0, 0.16) 0px 10px 36px 0px, rgba(0, 0, 0, 0.06) 0px 0px 0px 1px;
        transition: 0.3s all;
    }
    .current-plan-head {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .current-plan-title {
            font-size: 18px;
            font-weight: bold;
            color: black;
        }

        .current-plan-status {
            background: var(--color-bg-active);
            color: var(--color-text-primary-strong-active);
            padding: 3px 10px;
            border-radius: 5px;
            cursor: pointer;
        }
    }

    .current-plan-body {
        display: flex;
        justify-content: space-between;
        align-items: center;

        .current-plan-details {
            .plan-detail {
                display: flex;
                align-items: center;
                gap: 10px;

                :nth-child(1) {
                    //width: max-content;
                    width: 100px !important;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }

                :nth-child(2) {
                    font-weight: bold;
                    white-space: nowrap;
                }
            }
        }

        .image {
            width: 80px;
            height: 80px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 10px;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }
}
</style>
